import { CoreSignupInfoService } from "../core/signup-info-service";

export class ProdSignupInfoService extends CoreSignupInfoService
{
    getBaseUrl = ()=> `https://prod.best-experiences.com/invitation-signup-info/api/new-vendors-portal`;
}